import { Users } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconUsers(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <Users />
    </IconWrapper>
  );
}
